module.exports = __webpack_public_path__ + "img/sleeve_opening.421ec536.png";